// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3hzno","content":"styles_content__wlJyj","selectAll":"styles_selectAll__10XL1"};